import { LookupModel } from '../lookup-model';

export class ValueModel extends LookupModel {
  valueId: number;
  variableId: number;
  description: string;
}